import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { PrimaryButton } from 'office-ui-fabric-react';
import { showFlashMessage } from '../../actions/ui';
import TextButton from '../../components/TextButton';
import ProductForm from '../../components/ProductForm';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './AddProduct.style';

const AddProduct = () => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const ref = useRef();

  const handleCancel = () => {
    history.push(`/products`);
  };

  const handleSave = async () => {
    setIsSubmitting(true);

    await ref.current.submitForm();
    if (ref.current && !isEmpty(ref.current.errors)) {
      setIsSubmitting(false);
    }
  };

  const handleSuccess = product => {
    setIsSubmitting(false);
    history.push(`/products/${product.tokenId}`);
    dispatch(showFlashMessage('Product token created', { type: 'success' }));
  };

  return (
    <>
      <PageTitle>Create Product</PageTitle>

      <Main>
        <Module>
          <ModuleContent>
            <ProductForm ref={ref} onSuccess={handleSuccess} />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </TextButton>
          {!isSubmitting ? (
            <PrimaryButton type="submit" onClick={handleSave} disabled={isSubmitting}>
              Save and Continue
            </PrimaryButton>
          ) : (
            <SavingIndicator />
          )}
        </div>
      </Main>
    </>
  );
};

export default AddProduct;
